// @flow

import i18n from 'i18next';
import type { UserInputValidationErrorPayload } from './types';
import {
  SERVER_ERROR_MESSAGE_DEFAULT,
  SERVER_ERROR_MESSAGE_KEY,
} from './constants';

export function serverErrorMessage(payload: ?UserInputValidationErrorPayload, fallback?: string): string {
  return payload && payload.message
    || fallback
    || i18n.t(SERVER_ERROR_MESSAGE_KEY, { defaultValue: SERVER_ERROR_MESSAGE_DEFAULT });
}
